import { render, staticRenderFns } from "./OtherInformationCard.vue?vue&type=template&id=58fb01cd&"
import script from "./OtherInformationCard.vue?vue&type=script&lang=js&"
export * from "./OtherInformationCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports